export default __webpack_public_path__ + "registrodatosadicionales.jpg";